import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class ProfessionalCategory extends Mappeable {

    idTypeCategoryPk: number;
    txtTypeCategory: string;
    isBoss: number;
    nmrLevel: number;
    nmrOrder: number;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
        this.nmrLevel = this.nmrLevel ??  0 
        this.nmrOrder = this.nmrOrder ??  0 
    }

    public mapToBack() {
        return {
            txtTypeCategory: this.txtTypeCategory,
            mrkActive: this.mrkActive,
            nmrLevel: this.nmrLevel,
            nmrOrder: this.nmrOrder,
            isBoss: this.isBoss 
        }
    }

}